import { Card } from "primereact/card";
import * as client from "../../client";
import { ClientId, featureEnabled } from "../../client-features";
import { PantheonAvatarWithoutMenu } from "../../components/avatar/Avatar";
import { CommentContainer } from "../../components/comments/Comment";
import { CRMContact } from "../../components/crm-contact/CRMContact";
import { GoogleGroupAdminEdit } from "../../components/google-group/GoogleGroupAdminEdit";
import { IfFeatureEnabled } from "../../IfFeatureEnabled";
import { displayNameForUser } from "../../util";
import { AppetiteIcon } from "./appetite/AppetiteIcon";
import { BorBadge } from "./bor/BorBadge";
import { CompanyInfoHeader } from "./CompanyInfoHeader";
import { SafeReportResponse } from "./Conversion";
import { ClearanceStatusHover } from "./dashboard/clearance/ClearanceStatusHover";
import styles from "./SpecialtyReport.module.css";

export const DesktopReportHeader = ({
  safeResponse,
  specialtyPropertyInfo,
  reportName,
  assignee,
  handler,
  bor,
  clientId,
  me,
  showBorModal,
  actionButtons,
}: {
  safeResponse: SafeReportResponse;
  specialtyPropertyInfo: client.ReportResponse;
  reportName: string;
  assignee: client.User | undefined;
  handler: client.User | undefined;
  bor: client.BorLetterResponse | null;
  clientId: ClientId;
  me: client.User | undefined;
  showBorModal: (reportId: string) => void;
  actionButtons: React.ReactNode;
}) => {
  return (
    <Card
      title={reportName}
      subTitle={
        <div className={styles.statusContainer}>
          <div className={styles.roundedHeaderPiece}>
            <div className={styles.assigneeContainer}>
              <PantheonAvatarWithoutMenu
                label={displayNameForUser(assignee)}
                imageUrl={assignee?.profile_image_url}
                showName={true}
              />
            </div>
          </div>
          <IfFeatureEnabled feature="handler-column">
            <div className={styles.roundedHeaderPiece}>
              <div className={styles.assigneeContainer}>
                <PantheonAvatarWithoutMenu
                  label={displayNameForUser(handler)}
                  imageUrl={handler?.profile_image_url}
                  showName={true}
                />
              </div>
            </div>
          </IfFeatureEnabled>
          <div className={styles.roundedHeaderPiece}>
            <ClearanceStatusHover
              reportId={specialtyPropertyInfo.report_id}
              status={specialtyPropertyInfo.status}
            />
          </div>
          {bor && (
            <div className={styles.roundedHeaderPiece}>
              <BorBadge
                bor={bor}
                reportId={specialtyPropertyInfo.report_id}
                onClick={() => showBorModal(specialtyPropertyInfo.report_id)}
              />
            </div>
          )}
          {(specialtyPropertyInfo.google_group_email ||
            featureEnabled(clientId, "edit-team", { user: me })) && (
            <div className={styles.roundedHeaderPiece}>
              <GoogleGroupAdminEdit
                reportId={specialtyPropertyInfo.report_id}
                googleGroupEmail={
                  specialtyPropertyInfo.google_group_email ?? null
                }
              />
            </div>
          )}
          <div className={styles.roundedHeaderPiece}>
            <CRMContact
              contact={safeResponse.broker_contact}
              brokerageName={safeResponse.report_json.company_info.broker_name}
              reportId={specialtyPropertyInfo.report_id}
              size="full_width"
            />
          </div>
          <div className={styles.roundedHeaderPiece}>
            <AppetiteIcon
              naicsInfo={specialtyPropertyInfo.report_json.naics_info}
              precomputedMetadata={specialtyPropertyInfo.precomputed_metadata}
              googleGroupEmail={
                specialtyPropertyInfo.google_group_email ?? null
              }
              createdAtTs={specialtyPropertyInfo.created_at_ts}
              size="full_width"
              status={specialtyPropertyInfo.status}
            />
          </div>
        </div>
      }
      style={{ position: "relative" }}
    >
      <CompanyInfoHeader specialtyPropertyInfo={safeResponse} />
      <div className={styles.horizontalContainer}>
        <IfFeatureEnabled feature="comments">
          <CommentContainer
            reportName={reportName}
            reportId={specialtyPropertyInfo.report_id}
            autoOpenFromUrl
          />
        </IfFeatureEnabled>
        <span>{safeResponse.report_json.company_info.company_description}</span>
      </div>
      <div className={styles.topRightButtons}>{actionButtons}</div>
    </Card>
  );
};
